export default __webpack_public_path__ + "d7703de4b0ee6702864efb7a4179695c.svg";